/* ============================================================
   OSMANLI DOĞAL TAŞ — Numeroloji hesap motoru (Pisagor sistemi)

   TÜRKÇE KARARI: Pisagor tablosu Latin alfabesi içindir. Türkçeye özgü
   harfler en yakın Latin karşılığına indirgenir (Ç→C, Ğ→G, İ→I, Ö→O,
   Ş→S, Ü→U). Bu, Türkiye'de yaygın kabul gören yaklaşımdır ve sayfada
   kullanıcıya açıkça belirtilir.

   SESLİ HARFLER: A E I İ O Ö U Ü. Y Türkçede sessizdir; bu yüzden
   sessiz sayılır (İngilizce numerolojisinden ayrılan bilinçli bir tercih).
   ============================================================ */
(function (g) {
  'use strict';

  /* Pisagor: A=1 … I=9, J=1 … R=9, S=1 … Z=8 */
  var TABLO = {
    A:1, B:2, C:3, D:4, E:5, F:6, G:7, H:8, I:9,
    J:1, K:2, L:3, M:4, N:5, O:6, P:7, Q:8, R:9,
    S:1, T:2, U:3, V:4, W:5, X:6, Y:7, Z:8
  };
  var TR_INDIRGE = { 'Ç':'C', 'Ğ':'G', 'İ':'I', 'Ö':'O', 'Ş':'S', 'Ü':'U', 'Â':'A', 'Î':'I', 'Û':'U' };
  var SESLI = 'AEIİOÖUÜ';                       // Y sessiz sayılır

  var USTA = [11, 22, 33];

  /** Sayıyı tek haneye indirger; usta sayıları (11/22/33) korur. */
  function indirge(n, ustaKoru) {
    if (ustaKoru === undefined) ustaKoru = true;
    while (n > 9) {
      if (ustaKoru && USTA.indexOf(n) > -1) return n;
      var t = 0;
      String(n).split('').forEach(function (d) { t += +d; });
      n = t;
    }
    return n;
  }

  /** Ham toplamı ve indirgenmiş değeri birlikte döndürür (usta sayı izlenebilsin). */
  function indirgeDetay(n) {
    var adimlar = [n];
    var v = n;
    while (v > 9 && USTA.indexOf(v) === -1) {
      var t = 0;
      String(v).split('').forEach(function (d) { t += +d; });
      v = t;
      adimlar.push(v);
    }
    return { deger: v, adimlar: adimlar, usta: USTA.indexOf(v) > -1 };
  }

  /** Türkçe metni Pisagor harflerine indirger. */
  function harfler(metin) {
    var s = String(metin || '').toLocaleUpperCase('tr');
    var out = [];
    for (var i = 0; i < s.length; i++) {
      var c = s[i];
      if (TR_INDIRGE[c]) c = TR_INDIRGE[c];
      if (TABLO[c]) out.push({ harf: s[i], latin: c, deger: TABLO[c],
                               sesli: SESLI.indexOf(s[i]) > -1 });
    }
    return out;
  }

  function harfToplam(liste) {
    var t = 0; liste.forEach(function (h) { t += h.deger; }); return t;
  }

  /* ---------------------------------------------------------- ana sayılar */

  /** Yaşam Yolu — doğum tarihinin toplamı. Gün/ay/yıl ayrı ayrı indirgenir. */
  function yasamYolu(gun, ay, yil) {
    var g = indirge(gun), a = indirge(ay), y = indirge(yil);
    return indirgeDetay(g + a + y);
  }

  /** Doğum Günü Sayısı — sadece gün. */
  function dogumGunu(gun) { return indirgeDetay(gun); }

  /** Kader / İfade — tam isimdeki TÜM harfler. */
  function kader(tamIsim) { return indirgeDetay(harfToplam(harfler(tamIsim))); }

  /** Ruh Arzusu — yalnızca sesli harfler. */
  function ruhArzusu(tamIsim) {
    return indirgeDetay(harfToplam(harfler(tamIsim).filter(function (h) { return h.sesli; })));
  }

  /** Kişilik — yalnızca sessiz harfler. */
  function kisilik(tamIsim) {
    return indirgeDetay(harfToplam(harfler(tamIsim).filter(function (h) { return !h.sesli; })));
  }

  /** Olgunluk — Yaşam Yolu + Kader. Yaşamın ikinci yarısında belirginleşir. */
  function olgunluk(yy, kd) { return indirgeDetay(yy + kd); }

  /**
   * Kişisel Yıl — bu yıl hangi döngüdesin (1-9).
   * Döngü tanımı gereği 1-9 arasıdır; usta sayı korunmaz, yoksa döngü kırılır.
   */
  function kisiselYil(gun, ay, yil, refYil) {
    var suYil = refYil || new Date().getFullYear();
    return indirge(indirge(gun, false) + indirge(ay, false) + indirge(suYil, false), false);
  }

  /** Kişisel Ay — kişisel yıl + içinde bulunulan takvim ayı. */
  function kisiselAy(gun, ay, yil, refYil, refAy) {
    var d = new Date();
    var ky = kisiselYil(gun, ay, yil, refYil || d.getFullYear());
    return indirge(ky + (refAy || (d.getMonth() + 1)), false);
  }

  /** Karmik dersler — isimde HİÇ geçmeyen 1-9 rakamları. */
  function karmikDersler(tamIsim) {
    var v = {}, l = harfler(tamIsim);
    l.forEach(function (h) { v[h.deger] = (v[h.deger] || 0) + 1; });
    var eksik = [];
    for (var i = 1; i <= 9; i++) if (!v[i]) eksik.push(i);
    return { eksik: eksik, sayim: v };
  }

  /**
   * Zirveler (Pinnacles) — hayatın dört dönemi ve her dönemin teması.
   * Klasik yöntem: 1. zirve gün+ay, 2. gün+yıl, 3. 1.+2., 4. ay+yıl.
   */
  function zirveler(gun, ay, yil) {
    var g = indirge(gun), a = indirge(ay), y = indirge(yil);
    var yy = yasamYolu(gun, ay, yil).deger;
    var p1 = indirge(g + a), p2 = indirge(g + y), p3 = indirge(p1 + p2), p4 = indirge(a + y);
    var bitis1 = 36 - (USTA.indexOf(yy) > -1 ? indirge(yy, false) : yy);
    return [
      { no: 1, sayi: p1, bas: 0,           bit: bitis1 },
      { no: 2, sayi: p2, bas: bitis1 + 1,  bit: bitis1 + 9 },
      { no: 3, sayi: p3, bas: bitis1 + 10, bit: bitis1 + 18 },
      { no: 4, sayi: p4, bas: bitis1 + 19, bit: 99 }
    ];
  }

  /** Zorluklar (Challenges) — farkların mutlak değeri; usta sayı uygulanmaz. */
  function zorluklar(gun, ay, yil) {
    var g = indirge(gun, false), a = indirge(ay, false), y = indirge(yil, false);
    var c1 = Math.abs(a - g), c2 = Math.abs(g - y), c3 = Math.abs(c1 - c2), c4 = Math.abs(a - y);
    return [c1, c2, c3, c4];
  }

  /**
   * Lo Shu doğum karesi — doğum tarihindeki rakamların 3×3 ızgaradaki dağılımı.
   * Izgara yerleşimi (geleneksel): 4 9 2 / 3 5 7 / 8 1 6
   */
  var LOSHU_DIZILIM = [4, 9, 2, 3, 5, 7, 8, 1, 6];
  function loShu(gun, ay, yil) {
    var basamak = (String(gun) + String(ay) + String(yil)).split('')
      .map(Number).filter(function (n) { return n > 0; });   // 0 ızgaraya girmez
    var sayim = {};
    basamak.forEach(function (n) { sayim[n] = (sayim[n] || 0) + 1; });
    return { dizilim: LOSHU_DIZILIM, sayim: sayim, basamaklar: basamak };
  }

  /* ---------------------------------------------------------- tam profil */

  function profil(ad, soyad, gun, ay, yil) {
    var tamIsim = (ad + ' ' + soyad).trim();
    var yy = yasamYolu(gun, ay, yil);
    var kd = kader(tamIsim);
    var ra = ruhArzusu(tamIsim);
    var ks = kisilik(tamIsim);
    var ol = olgunluk(yy.deger, kd.deger);
    var suYil = new Date().getFullYear();
    var yas = suYil - yil;
    var zr = zirveler(gun, ay, yil);
    var aktifZirve = zr.filter(function (z) { return yas >= z.bas && yas <= z.bit; })[0] || zr[3];

    return {
      tamIsim: tamIsim,
      yasamYolu: yy,
      dogumGunu: dogumGunu(gun),
      kader: kd,
      ruhArzusu: ra,
      kisilik: ks,
      olgunluk: ol,
      kisiselYil: kisiselYil(gun, ay, yil, suYil),
      kisiselAy: kisiselAy(gun, ay, yil, suYil),
      karmik: karmikDersler(tamIsim),
      zirveler: zr,
      aktifZirve: aktifZirve,
      zorluklar: zorluklar(gun, ay, yil),
      loShu: loShu(gun, ay, yil),
      harfDetay: harfler(tamIsim),
      yas: yas,
      suYil: suYil
    };
  }

  g.ODTNumero = {
    profil: profil, indirge: indirge, indirgeDetay: indirgeDetay,
    harfler: harfler, harfToplam: harfToplam,
    yasamYolu: yasamYolu, kader: kader, ruhArzusu: ruhArzusu, kisilik: kisilik,
    olgunluk: olgunluk, kisiselYil: kisiselYil, kisiselAy: kisiselAy,
    karmikDersler: karmikDersler,
    zirveler: zirveler, zorluklar: zorluklar, loShu: loShu,
    TABLO: TABLO, SESLI: SESLI, USTA: USTA, LOSHU_DIZILIM: LOSHU_DIZILIM
  };
})(typeof window !== 'undefined' ? window : globalThis);
